import { Button } from "primereact/button";
import { HamburgerContainer } from "./styles";
import { RxHamburgerMenu } from "react-icons/rx";
import { OverlayPanel } from "primereact/overlaypanel";

const Hamburger = ({ children, menuRef, onMenuToggle }) => {
  return (
    <HamburgerContainer>
      <Button
        title="mobile navigation menu"
        onClick={onMenuToggle}
        className="p-button-rounded"
        icon={() => <RxHamburgerMenu />}
      />
      <OverlayPanel ref={menuRef} dismissable>
        {children}
      </OverlayPanel>
    </HamburgerContainer>
  );
};

export default Hamburger;
